'use strict';

function Attributes(){

    /********************************/
    // Apply attributes
    /********************************/
    this.applyAttributes = function() {
        if ($('#step1').length > 0) {
            $('#step1').find('[id="ANSWER.TTQ.MENSYS.1."], [id="ANSWER.TTQ.MENSYS.2."]').prop('required', true);
        }
        if ($('#coc_loc_app2_questions').length > 0) {
            $('#coc_loc_app2_questions').find('[id="ANSWER.TTQ.MENSYS.1."]').prop('required', true);
        }
    };
}
